'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { jetbrainsMono } from 'utils/fonts';
import {
  SharedDetailModal,
  SharedDetailModalSection,
} from './SharedDetailModal';
import styles from './DiagnosticLearnMoreModal.module.css';

export interface ModalSection {
  title?: string;
  content: string;
  subtitle?: string;
  defaultOpen?: boolean;
}

export interface LearnMoreModalData {
  thumbnailSrc?: string;
  sectionImageSrc?: string;
  sections?: ModalSection[];
  description?: string;
  benefits?: string[];
  ctaText: string;
}

interface DiagnosticLearnMoreModalProps {
  title: string;
  modalData: LearnMoreModalData;
  onClose: () => void;
  onCtaClick?: () => void;
}

export const DiagnosticLearnMoreModal: React.FC<
  DiagnosticLearnMoreModalProps
> = ({ title, modalData, onClose, onCtaClick }) => {
  const t = useTranslations('performance-lab');
  const tPerformanceLabs = useTranslations('diagnostics');
  const { sections = [], ctaText, thumbnailSrc, sectionImageSrc, description, benefits } = modalData;
  const resolveText = (value: string): string => {
    const buyTranslation = tPerformanceLabs(value);
    if (buyTranslation !== value) return buyTranslation;
    const lpTranslation = t(value);
    return lpTranslation !== value ? lpTranslation : value;
  };
  const modalSections: SharedDetailModalSection[] = sections.map((section) => ({
    title: section.title,
    content: section.content,
  }));

  return (
    <SharedDetailModal
      title={title}
      iconSrc={thumbnailSrc}
      iconAlt=""
      sections={modalSections}
      sectionImageSrc={sectionImageSrc}
      description={description}
      benefits={benefits}
      onClose={onClose}
      closeAriaLabel={t('modal.closeAria')}
      resolveText={resolveText}
      footer={
        <button
          type="button"
          onClick={onCtaClick}
          className={`${styles.modalFooterCta} ${jetbrainsMono.className}`}
        >
          {ctaText}
        </button>
      }
    />
  );
};
